// src/hooks/useData.js
import { useState, useEffect, useCallback } from 'react';
import { getCards, addCard, deleteCard, getEntries, addEntry, addEntries, deleteEntry, deleteEntriesByGroup, deleteEntriesByCard } from '../services/db';
import { getBillKey, getParcelBillKeys, todayStr } from '../services/billing';

export function useData(user) {
  const [cards, setCards] = useState([]);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const [c, e] = await Promise.all([getCards(user.uid), getEntries(user.uid)]);
      setCards(c);
      setEntries(e);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { reload(); }, [reload]);

  // ─── CARTÕES ───
  const handleAddCard = async (cardData) => {
    await addCard(user.uid, cardData);
    await reload();
  };

  const handleDeleteCard = async (cardId) => {
    await deleteCard(cardId);
    await deleteEntriesByCard(user.uid, cardId);
    await reload();
  };

  // ─── LANÇAMENTOS ───
  const handleAddNormal = async ({ desc, val, cat, cardId, date }) => {
    const card = cards.find(c => c.id === cardId);
    const billKey = getBillKey(card, date);
    await addEntry(user.uid, {
      desc, val: parseFloat(val), cat, cardId, date,
      type: 'normal', billKey,
      parcelIdx: null, parcelTotal: null, groupId: null, totalValue: null
    });
    await reload();
  };

  const handleAddParcel = async ({ desc, val, parc, cat, cardId, date }) => {
    const card = cards.find(c => c.id === cardId);
    const billKeys = getParcelBillKeys(card, date, parc);
    const parcVal = parseFloat(val) / parc;
    const groupId = Date.now().toString();
    const [,, purchaseDay] = date.split('-');
    const entriesArr = billKeys.map((bk, i) => {
      const [by, bm] = bk.split('-');
      const entryDate = `${by}-${bm}-${purchaseDay}`;
      return {
        desc, val: parcVal, cat, cardId,
        date: entryDate,
        type: 'parcel', billKey: bk,
        parcelIdx: i + 1, parcelTotal: parc,
        groupId, totalValue: parseFloat(val)
      };
    });
    await addEntries(user.uid, entriesArr);
    await reload();
  };

  const handleDeleteEntry = async (entry) => {
    if (entry.type === 'parcel') {
      await deleteEntriesByGroup(user.uid, entry.groupId);
    } else {
      await deleteEntry(entry.id);
    }
    await reload();
  };

  return {
    cards, entries, loading,
    addCard: handleAddCard,
    deleteCard: handleDeleteCard,
    addNormal: handleAddNormal,
    addParcel: handleAddParcel,
    deleteEntry: handleDeleteEntry,
  };
}
